<template>
    <!-- 头部[[ -->
    <div class="g-header">
        <div class="container f-clearfix">
            <div class="tgl-logo"><a class="logo" href="/">TGL创作联盟</a></div>
<!--             <div class="tgl-menu">
                <ul class="menu">
                    <li class="list"><a class="active" href="/">首页</a></li>
                    <li class="list"><a href="/home/advantage.shtml">产品优势</a></li>
                    <li class="list"><a href="/works/productionList.shtml">作品榜单</a></li>
                    <li class="list"><a href="/user/join_us_organ.shtml">加入我们</a></li>
                </ul>
            </div> -->
            <div class="tgl-leave" v-show="!$route.meta.noLoginBtn">
                <div class="tgl-leave" v-show="!$store.state.status.login">
                    <div class="leave" style="float: right;"><a href="javascript:;" @click="login">登录</a></div>
                </div>
                <div class="tgl-leave" v-show="$store.state.status.login">
                    <el-menu class="el-menu-demo user" mode="horizontal" :router="true" :collapse-transition="false">
                        <el-submenu index="1">
                            <template slot="title">
                                <router-link :to="{name: 'v4-personal-personal'}"><img class="user-head" :src="avatar" :onerror="defaultImg"><span class="user-name f-hide-col-1" v-text="$store.state.realUserInfo.userName"></span></router-link>
                            </template>
                            <el-menu-item index="v4-personal-personal">个人中心</el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <div class="leave"><a href="javascript:;" @click="loginOut">退出</a></div>
                </div>
            </div>
        </div>
        <login-model ref="loginBox" :closeBtn="$route.meta.needLogin === false"  :disableType="[$route.meta.disableLoginType]"></login-model>
    </div>
    <!-- 头部]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/components/v4/header/header_v4.scss';
    .g-header /deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title{
        border-bottom-color: transparent;
    }
    .g-header /deep/ .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow{
        display: none;
    }
    .g-header /deep/ .el-menu.el-menu--horizontal{
        border: 0;
    }
</style>
<script>
import loginModel from "Components/v4/pop/login_pop";
import {
    loginOut 
} from 'Services/getData.js';

export default {
    data() {
        return {
            defaultImg: `this.src="${  require('../../../assets/img/pages/v4/admin.png')  }"`
        }
    },
    components: {
        loginModel
    },
    computed: {
        avatar(){
            if(this.$store.state.realUserInfo.avatar){
                return this.$store.state.realUserInfo.avatar
            }else{
                return '';
            }
        }
    },
    mounted(){
        // loginBox
    },
    methods: {
        login(){
            this.$refs.loginBox.show = true;
        },
        async loginOut(){
            let res = await loginOut();
            if(res.data.code == 0){
                location.href=`${document.location.protocol}//${document.location.hostname}`;
            }
        }
    }
}
</script>

